export default __webpack_public_path__ + "static/media/blog-card.b9d38cb0.JPG";